import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Commission } from '@app/shared/interfaces/commission';
import { AppConfig } from '@config/app.config';
import { CommissionsRepository } from '@core/repositories/commissions.repository';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiCommissionsRepository implements CommissionsRepository {
  public url = this.appConfig.URL + '/segments/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(commission: Commission): Observable<any> {
    const data = {
      data: {
        id: commission.id,
        type: 'Segment'
      }
    };
    return this.http.post(this.url, data);
  }

  edit(commission: Commission): Observable<any> {
    const data = {
      data: {
        id: commission.id,
        type: 'Segment'
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
